var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.hrm.message.general") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.hrm.message.name") + " *" }
                  }),
                  _vm._v(" "),
                  _c("BaseInput", {
                    attrs: {
                      classNames: [{ "is-invalid": _vm.$v.input.name.$error }],
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.$v.input.name.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.input.name, "$model", $$v)
                      },
                      expression: "$v.input.name.$model"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.input.name
        ? _c(
            "Section",
            [
              _c("SectionHeader", {
                attrs: { title: _vm.$t("apps.hrm.message.assignemployee") }
              }),
              _vm._v(" "),
              _c(
                "FormRow",
                [
                  _c(
                    "Col",
                    { attrs: { className: "col-lg-12" } },
                    [
                      !_vm.employees.length
                        ? _c("BaseNotFoundData", {
                            attrs: {
                              title: _vm.$t(
                                "apps.payroll.message.notfoundemployeee"
                              ),
                              detail: _vm.$t(
                                "apps.payroll.message.createnewemployee"
                              )
                            }
                          })
                        : _c("BaseAssignItems", {
                            attrs: {
                              items: _vm.assignitems,
                              primaryId: _vm.primaryId,
                              primaryName: _vm.primaryName,
                              disabled: _vm.disabled
                            },
                            model: {
                              value: _vm.input.assignIds,
                              callback: function($$v) {
                                _vm.$set(_vm.input, "assignIds", $$v)
                              },
                              expression: "input.assignIds"
                            }
                          })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showActionButtons
        ? _c("BaseFormAction", {
            attrs: {
              textCancel: _vm.$t("button.cancel"),
              textSubmit: _vm.$t("button.save"),
              isSubmitted: _vm.isSubmitted
            },
            on: { onCancel: _vm.handleCancel, onSubmit: _vm.handleSubmit }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68ae8700", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68ae8700","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/HrmPositionForm.vue
// module id = null
// module chunks = 